// export const API_PATH = "https://macumirabackendapi.azurewebsites.net/api/";
//export const API_PATH = "https://macumira.api.abarlatech.com/api/";

// Determine which API path to use based on environment
export const ACTIVE_API_PATH = "https://localhost:7108/"  // Local development


export const API_ROUTE = {
  AUTH: {
    FORGOT_PASSWORD: "ForgotPassword",
    CHECK_HASH: "ForgotPassword/CheckHash",
    FORGOT_CHANGE_PASSWORD: "ForgotPassword/ChangePasswordUsingHash",
    LOGGED_IN: "Signin/Login",
    CHANGE_PASSWORD: "ForgotPassword/ChangePassword",
  },
  ORGANIZATIONS: {
    CRUD_ORGANIZATIONS: "Organizations",
    REPORTS: "Reports",
    STORE_REPORT: "Reports/Store_Report",
    STORE_ORG_REPORT: "Reports/Org_Store_Report",
    ORGANIZATION_STORE_REPORT: "Reports/Organisation_Store_System_Report",
    STORE_DOCTOR_REPORT:"Reports/Store_Doctor_Report",
    ORGANIZATION_BILLING_REPORT:"Reports/Org_Billing_Report",
    SYSTEM_REPORT:"Reports/System_Report",
    DEVICE_REPORT:"Reports/Device_Report"
  },
  EMPLOYEES: {
    CRUD_EMPLOYEES: "Employees",
  },
  PATIENTS: {
    CRUD_PATIENTS: "Patients",
  },
  DOCTORS: {
    CRUD_DOCTORS: "Doctors",
  },
  AbarlaPartREF:{
    CRUD:"Inv_Abarla_Part_Ref"
  },
  InvLotLineDesc:{
    CRUD:"Inv_Lot_Line_Desc"
  },
  InvAssemblyCategoryType:{
    CRUD:"Inv_Assembly_Category_Type"
  },
  InvCategoryType:{
    CRUD:"Inv_Category_Type"
  },
  InvPartCategoryType:{
    CRUD:"Inv_Part_Category_Type"
  },
  COMPONENTS: {
    CRUD_COMPONENTS: "Components",
  },
  ORG_EMPLOYEE: {
    CRUD_ORG_EMPLOYEE: "Org_Employee",
  },
  TECHNICIANS: {
    CRUD_TECHNICIANS: "Technicians",
    GET_STR_TECH: "Get_Str_Technician",
  },
  TABS_TO_SERVER: {
    CRUD_SERVERS: "TabToServers",
  },
  EMPLOYEE_LOGS: {
    CRUD_LOGS: "EmployeeLogs",
  },
  STORES: {
    CRUD_STORES: "stores",
    STORE_ORGANISATION: "Stores/StoreForOrganisationId?OrganisationId",
  },
  MMSYSTEMS: {
    CRUD_SYSTEMS: "MMSystems",
  },
  SYSTEMS:{
    CRUD_SYSTEMS: "Inv_System",
  },
  MMDEVICES: {
    CRUD_DEVICES: "MMDevices",
    DEVICE_TYPE: "DeviceTypes",
  },
  INVOICE_RULES: {
    CRUD_INVOICE: "Invoice_Rules",
  },
  BILLING_CALCULTATION: {
    CRUD_BILLING: "BillingCalculation",
  },
  BILLING_SUMMARY: {
    CRUD_BILLING: "BillingSummary",
  },
  InvTreamentUsageDoc: {
    CRUD: "Inv_Treament_Usage_Doc",
    FILTERED_EXCEL: "Inv_Treament_Usage_Doc/filteredExcel",
    FILTERED_DATA: "Inv_Treament_Usage_Doc/filtered-data",
    FILTERED_BY_SYSID: "Inv_Treament_Usage_Doc/filtered-by-sysid",
    DOWNLOAD_FILE: "Inv_Treament_Usage_Doc/download-file",
    DOWNLOAD_FILTERED_FILES: "Inv_Treament_Usage_Doc/download-filtered-files"
  },
};
